import { StrictMode } from 'react'
import { Provider } from 'react-redux'

import store from './store'

import BaseLine from '~/core/components/base-line'
import Router from '~/router'
import Theme from '~/theme'

const App = () => (
  <StrictMode>
    <Provider store={store}>
      <Theme>
        <BaseLine />
        <Router />
      </Theme>
    </Provider>
  </StrictMode>
)

export default App
